export default __webpack_public_path__ + "static/screen_landing_ipad_main-60b75ad4cfeca6640bb114593e0567c6.png";